/*
 *   File : detail.js
 *   Author : https://evoqins.com
 *   Description : Sub admins detail page
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';

// custom style
import style from "../../Style/Component/admin.module.scss";

//Custom components
import { CustomTab, EmptyScreen, OverLay } from '../../Components/Others';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { StatisticCard } from '../../Components/Card';
import { Customers, Orders, Permissions, RmMapped } from './Helper';
import { Icon } from '../../Components/Icon';
import { ConfirmModal, ManageAdminRoleModal } from '../../Components/Modal';
import { APIService } from '../../Service';

const TAB_DATA = [
    { id: 1, label: 'Customers' },
    { id: 2, label: 'Orders' },
    { id: 3, label: 'RM mapped' },
    { id: 4, label: 'Access permissions' }
];

const AdminDetail = () => {

    const { state } = useLocation();
    const { id } = useParams();
    const navigate = useNavigate();
    const isRendered = useRef(true);

    const [selectedTab, setSelectedTab] = useState(0);

    const [toggleMenu, setToggleMenu] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [status, setStatus] = useState(false);
    const [loader, setLoader] = useState(true);

    const [subAdminDetail, setSubAdminDetail] = useState({});
    const [shortName, setShortName] = useState("");
    const [buttonLoader, setButtonLoader] = useState(false);

    const [manageRoleModal, setManageRoleModal] = useState(false);
    const [modalContent, setModalContent] = useState({ title: "", description: "" });

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
        if (isRendered.current === true) {
            _subAdminDetail();
        }
        isRendered.current = false;
    }, []);

    useEffect(() => {
        if (state !== null) {
            setSelectedTab(state.tab_index);
        } else {
            setSelectedTab(1);
        }
    }, [state]);

    useEffect(() => {
        if (confirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [confirm]);

    useEffect(() => {
        if (manageRoleModal === true) {
            const modal = new Modal(document.getElementById('manage-admin-role-modal'));
            modal.show();
        }
    }, [manageRoleModal]);

    // handle tab change
    const _handleTab = (tab_id) => {
        navigate(`/sub-admins/${id}`, {
            state: {
                tab_index: tab_id
            }
        });
    };

    // handle toggle activate or deactivate 
    const _handleToggleMenu = () => {
        setToggleMenu(prev => !prev);
    };

    // handle activate or deactivate 
    const _handleDeactivate = () => {
        setConfirm(true);
        setToggleMenu(false);

        if (subAdminDetail?.admin_data?.is_active) {
            setModalContent({
                title: "Confirm deactivation",
                description: "You are about deactivate Sub-admin. This action will revoke their access. Are you sure want to proceed"
            });
        } else {
            setModalContent({
                title: "Confirm Activation",
                description: "You are about to activate this sub-admin. This action will restore their access to the system. Are you sure you want to proceed?"
            });

        }
    };

    // API - sub admin detail
    const _subAdminDetail = () => {
        let is_post = true;
        let url = 'sub-admin/details';
        let request = {
            "id": id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {

                if (response.data.admin_data !== null) {
                    let updated_name = response.data.admin_data.name.split(" ");
                    let short_name;

                    if (updated_name.length > 1) {
                        short_name = updated_name[0].substring(0, 1) + updated_name[1].substring(0, 1)
                    } else {
                        short_name = updated_name[0].substring(0, 2)
                    }

                    setShortName(short_name.toUpperCase());
                }

                setSubAdminDetail(response.data);
            } else {
                setSubAdminDetail({})
                // toast.dismiss();
                // toast.error(response.message, { type: "error" });
            }
            setLoader(false);
        })
    };

    // API - block Sub admin
    const _blockSubAdmin = () => {
        let is_post = true;
        let url = 'sub-admin/block';
        let request = {
            "id": id
        }
        setButtonLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                // setIsCustomerBlocked(response.data.is_blocked);
                setModalContent({
                    title: "Confirm successfully",
                    description: subAdminDetail?.admin_data?.is_active ? "The account deactivated successfully." : "The account activated successfully."
                });
                setStatus(true);
                _subAdminDetail();
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
            setButtonLoader(false);
        })
    };

    return (
        <Fragment>
            {loader ?
                <div className='d-flex align-items-center justify-content-center min-vh-100'>
                    <img src={require("../../Assets/Image/loader.gif")}
                        draggable={false}
                        width={80}
                        height={80}
                        alt='loader'
                        className='text-center' />
                </div>
                :

                <section className='e-section-height pb-5' >
                    <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                        {subAdminDetail.admin_data != null &&
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                                <span className='text-decoration-hover-underline cursor-pointer'
                                    onClick={() => navigate("/sub-admins")}>Manage Sub Admins</span> / <span className='e-font-weight-600'>{subAdminDetail.admin_data.name}</span>
                            </p>
                        }
                    </div>

                    <div className='padding-52px-lr margin--80px-top'>
                        {/* Customer summary */}
                        <div className={`${style.e_summary_wrapper} e-bg-american-violet border-radius-16 padding-32px-tb px-4 position-relative`}>
                            <div className='d-flex gap-4 align-items-start'>

                                <div className='e-bg-blue-violet-light border-radius-64 padding-22px-lr py-4 rounded-circle w-76px h-76px d-flex flex-column justify-content-center align-items-center'>
                                    <p className='mb-0 e-text-cultured-light e-primary-font e-font-20 e-font-weight-400 line-height-20px'>
                                        {shortName}
                                    </p>
                                </div>

                                {/* Basic detail of admin  */}
                                {subAdminDetail.admin_data != null &&
                                    <div className='d-flex align-items-center gap-3'>
                                        <div className='d-flex flex-column gap-12px'>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px'>
                                                {subAdminDetail.admin_data.name}
                                            </p>
                                            <a href={`mailto:${subAdminDetail.admin_data.email}`} target='_blank' className='mb-0 d-flex e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px text-decoration-none text-decoration-hover-underline'>
                                                {subAdminDetail.admin_data.email}
                                            </a>
                                            <a href={`tel:${subAdminDetail.admin_data.mobile_number}`} className='d-flex e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px text-decoration-none text-decoration-hover-underline'>
                                                {subAdminDetail.admin_data.mobile_number}
                                            </a>
                                        </div>
                                        <div className='vr e-bg-lavender-blue'></div>
                                        <div className='d-flex flex-column gap-12px'>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                RM code: <span className='e-font-weight-600'>{subAdminDetail.admin_data.rm_code}</span>
                                            </p>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Reporting to: <span className='e-font-weight-600'>{subAdminDetail.admin_data.reporting_manager}</span>
                                            </p>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Added on: <span className='e-font-weight-600'>{subAdminDetail.admin_data.created_at}</span>
                                            </p>
                                        </div>
                                    </div>
                                }
                            </div>

                            {/* Toggle menu  */}
                            <>
                                <Icon icon="menu"
                                    size="1.5rem"
                                    height="1.375rem"
                                    color="#FFFFFF"
                                    className="position-absolute right-32px top-16px cursor-pointer"
                                    onClick={_handleToggleMenu} />

                                {toggleMenu &&
                                    <>
                                        <OverLay isOpen={toggleMenu} onClose={_handleToggleMenu} />
                                        <div className={`${style.e_menu_popup} e-bg-white border-radius-8 position-absolute right-32px top-48px padding-12px-tb padding-12px-lr  z-index-99 d-flex flex-column gap-12px`}>
                                            <div className='d-flex gap-1 align-items-center'>
                                                <img src={require("../../Assets/Image/Others/deactivate.svg").default}
                                                    draggable={false}
                                                    alt='deactivate' />

                                                <p className='mb-0 e-text-raisin-black e-primary-font e-font-12 e-font-weight-600 line-height-16px cursor-pointer'
                                                    onClick={_handleDeactivate}>
                                                    {subAdminDetail?.admin_data?.is_active ? "Deactivate Sub Admin" : "Activate Sub Admin"}
                                                </p>
                                            </div>

                                            {subAdminDetail?.admin_data?.is_active &&
                                                <div className='d-flex gap-1 align-items-center'>

                                                    <Icon icon="customers"
                                                        className="d-flex"
                                                        size={12} />
                                                    <p className='mb-0 e-text-raisin-black e-primary-font e-font-12 e-font-weight-600 line-height-16px cursor-pointer'
                                                        onClick={() => {
                                                            setManageRoleModal(true);
                                                            setToggleMenu(false);
                                                        }}>
                                                        Change Admin Role
                                                    </p>
                                                </div>
                                            }
                                        </div>
                                    </>
                                }
                            </>

                            {/* Statistic cards */}
                            {subAdminDetail?.admin_data != null &&

                                <div className='row row-cols-6 row-gap-4 pt-4'>
                                    <div className='col'>
                                        <StatisticCard title="Total AUM"
                                            value={subAdminDetail.admin_data.total_aum_text} />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Total users"
                                            value={subAdminDetail.admin_data.total_customers} />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="No of transactions"
                                            value={subAdminDetail.admin_data.total_transactions} />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Invested users"
                                            value={subAdminDetail.admin_data.invested_users} />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Non-invested users"
                                            value={subAdminDetail.admin_data.non_invested_users} />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Average AUM"
                                            value={subAdminDetail.admin_data.total_aum_text} />
                                    </div>
                                </div>
                            }
                        </div>

                        {/* Custom tab */}
                        <div className='d-flex py-4 mt-2'>
                            <CustomTab data={TAB_DATA}
                                selectedTab={selectedTab}
                                tooltip={false}
                                handleClick={_handleTab} />
                        </div>

                        <div className={`${style.e_data_wrapper} e-bg-ghost-white border-radius-16`}>
                            {selectedTab === 1 ?
                                <Customers />
                                :
                                selectedTab === 2 ?
                                    <Orders />
                                    :
                                    selectedTab === 3 ?
                                        subAdminDetail.rm_mapped_admins.length > 0 ?
                                            <RmMapped data={subAdminDetail} />
                                            :
                                            <EmptyScreen padding="py-5"
                                                image={require('../../Assets/Image/NotFound/no-data.png')}
                                                title='No results found'
                                                description={`We couldn' t find anything that matches your search. Try checking your spelling, using different keywords, or exploring popular funds.`}
                                            />

                                        :
                                        <Permissions data={subAdminDetail} />
                            }
                        </div>
                    </div>
                </section>
            }


            {/* confirm deactivate modal */}
            {confirm === true &&
                <ConfirmModal title={modalContent.title ?? ""}
                    description={modalContent.description ?? ""}
                    status={status}
                    loader={buttonLoader}
                    handleClose={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                            setModalContent({ title: "", description: "" });
                        }, 200);
                    }}
                    handleConfirm={_blockSubAdmin}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                            setToggleMenu(false);
                            setModalContent({ title: "", description: "" });
                        }, 200);
                    }} />
            }

            {manageRoleModal === true &&
                <ManageAdminRoleModal adminId={id}
                    data={subAdminDetail}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setManageRoleModal(false);
                        }, 200);
                        _subAdminDetail();
                        setLoader(true);
                    }}
                    handleClose={() => {
                        setTimeout(() => {
                            setManageRoleModal(false);
                        }, 200);
                    }} />
            }

        </Fragment>
    )
}

export default AdminDetail;
